import cn from 'classnames';
import { type ComponentPropsWithoutRef } from 'react';

export function Body({ className, ...props }: ComponentPropsWithoutRef<'div'>) {
    return <div className={cn('side-drawer__body', className)} {...props} />;
}
